import { Section } from './Section';

// -----------------------------------------------------------------------------
// Per-section explainer videos
// -----------------------------------------------------------------------------
// These are PRACTITIONER-facing: "how to read and use this section". They are not
// client education — clients receive the PDF, and this registry only drives the
// on-screen analysis panels.
//
// This registry is also the gate. A section listed here gets a small play icon
// beside its panel title; every other header renders exactly as before. There is
// no environment flag and no greyed-out placeholder — if a video hasn't been
// recorded yet, simply don't add a row.
//
// To publish one:
//   1. Record a short clip and upload it (unlisted YouTube is the proven path
//      here — the Help > Watch Demo modal has used it since launch).
//   2. Grab the id from the share URL:
//        YouTube https://www.youtube.com/watch?v=<ID>  -> youtube('<ID>')
//        Loom    https://www.loom.com/share/<ID>       -> loom('<ID>')
//   3. Add a row below, keyed by its Section.
// -----------------------------------------------------------------------------

export type SectionVideo = {
  // Embed URL; build it with youtube(...) or loom(...).
  src: string;
  // Shown in the modal header and in the icon's hover tooltip as "Watch: {title}".
  title: string;
};

export const loom = (id: string) => `https://www.loom.com/embed/${id}`;
export const youtube = (id: string) => `https://www.youtube.com/embed/${id}`;

// Leave empty and no play icons appear anywhere. Add the first entry once a clip
// is recorded — for example:
//
//   [Section.RESULTS_OVERVIEW]: {
//     src: youtube('paste-the-youtube-id-here'),
//     title: 'Reading the Results Overview',
//   },
//
export const SECTION_VIDEOS: Partial<Record<Section, SectionVideo>> = {};

export const getSectionVideo = (section: Section): SectionVideo | undefined =>
  SECTION_VIDEOS[section];
